import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('photo.index', params);
    },
    create: (context, params) => {
        return apiService.post('photo.index', params);
    },
    update: (context, params) => {
        return apiService.put('photo.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('photo.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
